var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes,attrs:{"data-testid":"bmv-badge"}},[(_vm.icon)?_c('i',{staticClass:"bmv-badge-icon",class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }